import React from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import UnitCard from './UnitCard';
import UnitInfoSection from './UnitInfoSection';
import ResourceTypes from 'legacy/packages/unit-outline/src/constants';

const UnitResourcesContainer = ({
  unitData,
  unitsLabel,
  widgetTagColumn,
  subjectId,
}) => {
  const {
    resources = [],
    unitId = '',
    title = '',
    subunits,
    displayName,
  } = unitData;
  const formattedResources = resources.length > 0 ? [{ ...resources[0] }] : [];
  const progressChecksInSubUnit = find(
    subunits,
    (subunit) => subunit.type === 'PPC',
  );
  const hasPPCInSubUnitResources =
    progressChecksInSubUnit && progressChecksInSubUnit.resources.length > 0;
  const topicQuestionResourceInSubUnit = find(subunits, ({ resources }) =>
    find(
      resources,
      (resource) => resource.__typename === ResourceTypes.PRACTICE_QUESTIONS,
    ),
  );

  // Check if topic question resource should be added.
  if (topicQuestionResourceInSubUnit) {
    formattedResources.push({
      __typename: ResourceTypes.QUESTION_BANK,
      url: `/${subjectId}/question_bank/questions/filters`,
      metadata: topicQuestionResourceInSubUnit.metadata || '[]',
    });
  }
  // Check if PPC resource should be added.
  if (hasPPCInSubUnitResources) {
    formattedResources.push({
      __typename: ResourceTypes.ASSESSMENT,
      url: `/${subjectId}/home`,
      queryType: 'progress-checks',
    });
  }

  if (isEmpty(formattedResources)) {
    return null;
  }

  const unitCardItems = formattedResources.map((resource) => {
    const {
      __typename: resourceType = '',
      url = '',
      queryType,
      metadata = '[]',
    } = resource;
    const unitCardProps = {
      unitId,
      unitsLabel,
      widgetTagColumn,
      subjectId,
      unitTitle: title,
      urlTo: url,
      resourceType,
      queryType,
      displayName,
      metadata,
    };
    return <UnitCard key={uniqid()} {...unitCardProps} />;
  });
  return (
    <div className="grid grid-flow-col auto-cols-max gap-x-36 justify-between bg-gray-100 h-62 mb-4">
      <div className="grid auto-rows-min gap-y-3 ml-16 mt-6">
        <span className="text-14 font-medium leading-normal tracking-wide">
          UNIT RESOURCES
        </span>
        <div className="grid grid-flow-col auto-cols-max auto-rows-min gap-x-4">
          {unitCardItems}
        </div>
      </div>
      <UnitInfoSection unitData={unitData} />
    </div>
  );
};

UnitResourcesContainer.displayName = 'UnitResourcesContainer';
UnitResourcesContainer.propTypes = {
  unitData: PropTypes.shape({
    resources: PropTypes.arrayOf(PropTypes.any),
    unitId: PropTypes.string,
    title: PropTypes.string,
    subunits: PropTypes.arrayOf(PropTypes.any),
    displayName: PropTypes.string,
  }).isRequired,
  unitsLabel: PropTypes.string,
  widgetTagColumn: PropTypes.string,
  subjectId: PropTypes.string,
};

UnitResourcesContainer.defaultProps = {
  unitsLabel: '',
  widgetTagColumn: '',
  subjectId: '',
};

export default UnitResourcesContainer;
